import React from "react";
import { Box, keyframes } from "@mui/material";
import { DP } from "./HomeStyles";
import { useLanguage } from "../../contexts/LanguageContext";

const marqueeAnim = keyframes`
  from { transform: translateX(0); }
  to   { transform: translateX(-50%); }
`;

const marqueeAnimRTL = keyframes`
  from { transform: translateX(0); }
  to   { transform: translateX(50%); }
`;

const ScrollingTicker: React.FC = () => {
  const { t, isRTL } = useLanguage();
  const services = t.home.ticker;
  const tickerItems = [...services, ...services];

  return (
    <Box component="section" aria-label="Services ticker" sx={{ width: "100%", backgroundColor: DP.navy, height: "52px", display: "flex", alignItems: "center", position: "relative", overflow: "hidden" }}>
      <Box sx={{ display: "inline-flex", alignItems: "center", animation: `${isRTL ? marqueeAnimRTL : marqueeAnim} 32s linear infinite`, willChange: "transform", flexShrink: 0 }}>
        {tickerItems.map((text, i) => (
          <Box key={i} component="span" sx={{ display: "inline-flex", alignItems: "center", fontWeight: 700, fontSize: "0.82rem", letterSpacing: isRTL ? "0.04em" : "0.22em", textTransform: isRTL ? "none" : "uppercase", color: "#FFFFFF", whiteSpace: "nowrap", textShadow: `0 0 18px ${DP.blueLight}, 0 0 6px rgba(66,165,245,0.5)`, "&::after": { content: '"✦"', display: "inline-block", mx: "26px", fontSize: "0.6rem", opacity: 0.45, color: DP.blueLight, textShadow: `0 0 10px ${DP.blueLight}` } }}>
            {text}
          </Box>
        ))}
      </Box>

      {/* Start-side fade */}
      <Box aria-hidden="true" sx={{ position: "absolute", top: 0, left: 0, width: "18%", height: "100%", background: `linear-gradient(to right, ${DP.navy} 0%, ${DP.navy} 30%, transparent 100%)`, pointerEvents: "none", zIndex: 2 }} />
      {/* End-side fade */}
      <Box aria-hidden="true" sx={{ position: "absolute", top: 0, right: 0, width: "18%", height: "100%", background: `linear-gradient(to left, ${DP.navy} 0%, ${DP.navy} 30%, transparent 100%)`, pointerEvents: "none", zIndex: 2 }} />
    </Box>
  );
};

export default ScrollingTicker;
